<section class="w-full min-h-screen p-5 lg:p-10 xl:p-16">
  <div
    class="w-full flex flex-col font-extrabold font-secondary text-10xl sm:text-14xl md:text-16xl md:text-20xl lg:text-24xl">
     <h1 i18n="@@autopark.offer.title" class="mx-auto text-secondary-650 text-center max-w-[1500px]">
       Nasze
       <span class="text-primary-500">
         rozwiązanie
       </span>
     </h1>
  </div>
  <div
    class="max-w-[1250px] mx-auto h-auto grid grid-cols-1 grid-rows-6 md:grid-cols-2 md:grid-rows-3 lg:grid-cols-3 lg:grid-rows-2 background-pattern rounded-[45px] md:rounded-[75px] shadow-2xl shadow-black/60 mt-5 p-7 sm:p-10 lg:p-16 parking-slot-container">
    @for (offerItem of offerData; track $index) {
      <div
        class="w-full h-[200px] sm:h-[250px] md:h-[300px] lg:h-[575px] parking-slot flex flex-col justify-start item-start lg:items-center p-3 sm:p-5">
        <h3
          class="text-secondary-300/70 font-stencil text-[4rem] sm:text-[6rem] md:text-[5rem] lg:text-[8rem] 2xl:text-[10rem]">
          {{ offerItem.id }}
        </h3>
        <span
          class="text-secondary-300/70 text-[1rem] sm:text-[1.25rem] lg:text-xl font-stencil text-left lg:text-center">
          {{ offerItem.content }}
        </span>
      </div>
    }
  </div>
</section>
